// eslint-disable-next-line unicorn/filename-case
import { merge, cloneDeep } from 'lodash-es';

/**
 * @param part
 */
function isPlaceholder(part) {
	return part.type === 'placeholder';
}

// Original function
/* function getTags(postParsed) {
	return postParsed.filter(isPlaceholder).reduce(function (tags, part) {
		console.log('tags', tags, 'part', part);
		tags[part.value] = tags[part.value] || {};
		if (part.subparsed) {
			tags[part.value] = merge(tags[part.value], getTags(part.subparsed));
		}
		return tags;
	}, {});
} */

/**
 * @param postParsed
 */
function getTags(postParsed) {
	const tags = [];
	postParsed.filter(isPlaceholder).forEach(part => {
		const tag = {
			placeholder: part.value,
			type: part.module || 'normal',
			childs: [],
		};
		if (part.subparsed) {
			tag.childs = getTags(part.subparsed);
		}
		tags.push(tag);
	});
	return tags;
}

/**
 * @param postParsed
 */
function getStructuredTags(postParsed) {
	return postParsed.filter(isPlaceholder).map(part => {
		if (part.subparsed) {
			part.subparsed = getStructuredTags(part.subparsed);
		}
		return part;
	}, {});
}

class InspectModule {
	constructor() {
		this.inspect = {};
		this.fullInspected = {};
		this.filePath = null;
		this.nullValues = [];
	}

	optionsTransformer(options, docxtemplater) {
		this.fileTypeConfig = docxtemplater.fileTypeConfig;
		this.zip = docxtemplater.zip;
		this.targets = docxtemplater.targets;
		this.templatedFiles = docxtemplater.getTemplatedFiles();
		this.fileType = docxtemplater.fileType;
		return options;
	}

	on(eventName) {
		if (eventName === 'attached') {
			this.inspect = {};
			this.fullInspected = {};
			this.filePath = null;
			this.nullValues = [];
		}
	}

	// eslint-disable-next-line complexity
	set(object) {
		if (object.data) {
			this.inspect.tags = object.data;
		}
		if (object.inspect) {
			if (object.inspect.filePath) {
				this.filePath = object.inspect.filePath;
				this.inspect = this.fullInspected[this.filePath] || {};
			}
			else if (object.inspect.content) {
				this.inspect.content = object.inspect.content;
			}
			else if (object.inspect.postparsed) {
				this.inspect.postparsed = cloneDeep(object.inspect.postparsed);
			}
			else if (object.inspect.parsed) {
				this.inspect.parsed = cloneDeep(object.inspect.parsed);
			}
			else if (object.inspect.lexed) {
				this.inspect.lexed = cloneDeep(object.inspect.lexed);
			}
			else if (object.inspect.xmllexed) {
				this.inspect.xmllexed = cloneDeep(object.inspect.xmllexed);
			}
			else if (object.inspect.resolved) {
				this.inspect.resolved = object.inspect.resolved;
			}
			this.fullInspected[this.filePath] = this.inspect;
		}
	}

	nullGetter(part, scopeManager, xt) {
		const inspected = this.fullInspected[xt.filePath];
		inspected.nullValues = inspected.nullValues || { summary: [], detail: [] };
		inspected.nullValues.detail.push({ part, scopeManager });
		inspected.nullValues.summary.push(
			scopeManager.scopePath.concat(part.value),
		);
	}

	getTags(file) {
		file = file || this.fileTypeConfig.textPath(this);
		return getTags(cloneDeep(this.fullInspected[file].postparsed));
	}

	// eslint-disable-next-line class-methods-use-this
	removeDuplicates(elements) {
		const filteredElements = elements.reduce((unique, o) => {
			if (!unique.some(object => object.placeholder === o.placeholder &&
				object.type === o.type &&
				object.childs.length === o.childs.length)) {
				unique.push(o);
			}
			return unique;
		}, []);
		return filteredElements;
	}

	getAllTags() {
		let returnValue = [];
		Object.keys(this.fullInspected).forEach(file => {
			returnValue = merge(returnValue, this.getTags(file));
		});

		return this.removeDuplicates(returnValue);
	}

	getStructuredTags(file) {
		file = file || this.fileTypeConfig.textPath(this);
		return getStructuredTags(cloneDeep(this.fullInspected[file].postparsed));
	}

	getAllStructuredTags() {
		return Object.keys(this.fullInspected).reduce((result, file) => result.concat(this.getStructuredTags(file)), []);
	}

	getFileType() {
		return this.fileType;
	}

	getTemplatedFiles() {
		return this.templatedFiles;
	}
}

export default InspectModule;
